<div class="palantir-table-stars">
  @for (items of [].constructor(5); track $index; let i = $index) {
    @if (i < value) {
      <palantir-icon name="star-filled" />
    }
    @if (i >= value) {
      <palantir-icon name="star-outline" />
    }
  }
</div>
